const styles = `:host([compact]){font:var(--goto-caption-medium);text-align:initial}`;export default styles;